/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useGetEventActionResourceReportQuery } from "~/generated/graphql";
import { showError } from "~/services/toast";

type Props = {
  eventActionId: string;
  eventId: string;
  resourceId: string;
};

export function useGetEventActionResourceReport({
  eventActionId,
  eventId,
  resourceId,
}: Props) {
  const {
    data: result,
    loading,
    error,
  } = useGetEventActionResourceReportQuery({
    variables: {
      eventActionId,
      eventId,
      resourceId,
    },
    onError(err) {
      showError(err.message);
    },
  });

  const data = result?.eventActionResourceReport;

  return { data, loading, error } as const;
}
